import reduceReducers from 'reduce-reducers'
import createFetchModule from '@utils/store/createFetchModule'
import createFetchSubmodule from '@utils/store/createFetchSubmodule'
import { FetchActionsWith } from '@typings/generic'

export const moduleName = 'returnReceiptsGrid'

const fetchModule = createFetchModule('@store/ReturnReceiptsGrid', 'LOAD', moduleName)
const submoduleExport = createFetchSubmodule('@store/ReturnReceiptsGrid', 'EXPORT', moduleName)

export const actionTypes = {
  ...fetchModule.actionTypes,
  export: submoduleExport.actionTypes,
}

export default reduceReducers(fetchModule.reducer)

export const actions: FetchActionsWith<typeof actionTypes> = {
  ...fetchModule.actions,
  export: submoduleExport.actions.run,
}

export const selectors: Selectors = {
  ...fetchModule.selectors,
  // ... ownSelectors
}
